const keyMirror = require("keymirror");

export const DashboardConstants = keyMirror({
  FETCH_DASHBOARD: undefined
});
